import React, { Fragment, useState } from "react";
import { Link } from "react-router";

import Button from "../../atoms/Button";
import GetIcon from "../../atoms/GetIcon";
import { useUserStore } from "../../../store/userStore";

function MobileNavEntry({ route, setIsOpen }: { route: any; setIsOpen: any }) {
  const user = useUserStore((state) => state.user);

  const [isItemOpen, setIsItemOpen] = useState(false);

  return (
    <div>
      {(route.auth && !user) ||
      (route.admin && (!user.roles || !user.roles.includes("admin"))) ||
      (route.premium && (!user.roles || !user.roles.includes("premium"))) ? (
        <></>
      ) : (
        <Button
          key={route.title}
          className="flex flex-row items-center w-full group py-3"
          style="tertiary"
          data-expanded={isItemOpen}
          aria-expanded={isItemOpen}
          onClick={() => setIsItemOpen(!isItemOpen)}
        >
          <div className="capitalize font-semibold group-hover:text-text-base">
            {route.title}
          </div>
          <div className="ml-auto mr-0">
            {isItemOpen ? (
              <GetIcon icon="up-arrow" />
            ) : (
              <GetIcon icon="down-arrow" />
            )}
          </div>
        </Button>
      )}

      {isItemOpen && (
        <div className="px-3 flex flex-col gap-3">
          {route.pages.map((page: any) => (
            <Fragment key={page.title}>
              {(page.auth && !user) ||
              (page.admin && (!user.roles || !user.roles.includes("admin"))) ||
              (page.premium &&
                (!user.roles || !user.roles.includes("premium"))) ? (
                <></>
              ) : (
                <Link
                  to={page.href}
                  key={page.title}
                  onClick={() => {
                    setIsOpen(false);
                  }}
                  className="group"
                >
                  <div className="flex mt-5">
                    {page.icon ? (
                      <div className="text-text-secondary">{page.icon}</div>
                    ) : (
                      ""
                    )}
                    <div className="ml-3 text-text-base group-hover:underline">
                      {page.title}
                    </div>
                  </div>
                </Link>
              )}
            </Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default MobileNavEntry;
